<template>
    <v-container fluid fill-height>
        <v-layout text-center wrap align-center>
            <v-flex xs12 sm12>
                <h1 class="display-1 my-5">
                    <span class="font-weight-bold">Criadores</span>
                    | Nova Música Gospel
                </h1>

                <v-layout class="my-5" grid-list-xl wrap justify-center>
                    <v-flex xs12 sm8 md5 xl4 mt-5 mb-5>
                        <v-progress-circular
                            v-show="!show_message"
                            :size="50"
                            indeterminate
                            color="primary"
                        ></v-progress-circular>

                        <v-alert
                            style="text-align:left;"
                            prominent
                            v-show="show_message"
                            :type="message_item.type"
                        >{{message_item.message}}</v-alert>
                    </v-flex>
                    <v-flex xs12 sm8 mt-5>
                        <v-btn outlined large text color="primary" :to="{name:'login'}">ENTRAR</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import VeeValidate from "vee-validate";
import LoginService from "../../app/Rest/auth";

var loginService = null;

Vue.use(VeeValidate);

export default {
    $_veeValidate: {
        validator: "new"
    },
    data: () => ({
        show_message: false,

        credential: {
            email: "",
            password: ""
        },
        message_item: { type: "success", message: null },
        dictionary: {
            attributes: {
                email: "E-mail Address"
                // custom attributes
            },
            custom: {
                email: {
                    required: "E-mail é um campo obrigatório.",
                    email: "Esse não parece um e-mail válido."
                },
                password: {
                    required: "Senha é um campo obrigatório.",
                    min: "Sua senha tem no minimo 8 caracteres."
                }
            }
        }
    }),
    created: function() {
        loginService = LoginService.build();
        let hash = this.$route.params.hash;
        if (hash.length != 40) {
            this.message_item.type = "error";
            this.message_item.message =
                "Link de confirmação inválido ou expirado.";
            this.show_message = true;
            return;
        }
        this.show_message = false;
        loginService
            .verify_email(hash)
            .then(e => {
                if (e.status == "error") {
                    this.message_item.type = "error";
                    this.message_item.message =
                        "Link de confirmação inválido ou expirado.";
                    return;
                }

                this.message_item.type = "success";
                this.message_item.message = e.msg;
            })
            .finally(() => {
                this.show_message = true;
            });
    },
    updated: function() {
        this.email = "";
        this.password = "";
    },
    mounted() {
        this.$validator.localize("pt_br", this.dictionary);
        //this.cover = this.product.cover;
    },
    methods: {
        ...mapActions(["user_authenticate_data"])
    }
};
</script>
